import script from "./PartialInvoiceHospitalTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PartialInvoiceHospitalTable.vue?vue&type=script&setup=true&lang=js"

import "./PartialInvoiceHospitalTable.vue?vue&type=style&index=0&id=177b9a24&lang=css"

const __exports__ = script;

export default __exports__